const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGearok16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.332 0.052734a8 8 0 0 0-1.957 0.40039l0.3125 1.4766c-0.65092 0.25017-1.251 0.6026-1.7832 1.0371l-1.1152-1.0039a8 8 0 0 0-1.3496 1.4766l1.125 1.0117c-0.37616 0.5727-0.66484 1.2075-0.8457 1.8848l-1.4844-0.15625a8 8 0 0 0-0.23438 1.8203 8 8 0 0 0 0.01367 0.16602l1.4941 0.15625c0.03521 0.70829 0.18676 1.389 0.43359 2.0215l-1.2949 0.74805a8 8 0 0 0 0.98828 1.7363l1.3125-0.75781c0.43383 0.53668 0.94924 1.0036 1.5293 1.3809l-0.60938 1.3711a8 8 0 0 0 1.8223 0.82617l0.61328-1.377c0.54181 0.14784 1.1106 0.22852 1.6973 0.22852 0.12021 0 0.23875-0.0032 0.35742-0.0098l0.31055 1.457a8 8 0 0 0 1.5703-0.29489l-1.2383-1.2383v-2.4141h2.4141l0.76172 0.76172 1.9668-3.2754 0.29102-0.48633h1.4863a8 8 0 0 0 0.080078-1 8 8 0 0 0-0.003906-0.16406l-1.5039-0.1582c-0.035208-0.70829-0.18676-1.389-0.43359-2.0215l1.3125-0.75781a8 8 0 0 0-0.36914-0.76758 8 8 0 0 0-0.63086-0.96289l-1.3184 0.76172c-0.43439-0.53737-0.95028-1.0053-1.5312-1.3828l0.61914-1.3887a8 8 0 0 0-1.8262-0.81445l-0.61719 1.3848c-0.54181-0.14784-1.1106-0.22852-1.6973-0.22852-0.12021 0-0.23875 0.00322-0.35742 0.00977zm0.66797 4.4473c1.9508 0 3.5 1.5492 3.5 3.5s-1.5492 3.5-3.5 3.5-3.5-1.5492-3.5-3.5 1.5492-3.5 3.5-3.5zm0 2a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5 1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0-1.5-1.5z",
    fill: "#666",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 10-2.625 4.375-1.375-1.375h-1v1l2 2h1l3-5v-1z",
    color: "#000000",
    fill: "#008000",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearok16);
export default __webpack_public_path__ + "static/media/gear.ok.16.0ea54d235b18581a3fbb2b387694b889.svg";
export { ForwardRef as ReactComponent };